import { useMutation, useQueryClient } from '@tanstack/react-query';

import { type UUID } from '~/types/common';

import { queryKeysDataSubscription } from '../queryKeys';

import { rerunExecutionLog } from './rerunExecutionLog';
import { type RerunExecutionLogMutationOptions } from './types';

/**
 * Custom hook for rerunning a failed execution log using mutations.
 *
 * @param options - Additional options for the useMutation hook.
 * @returns An object containing the mutation function and related properties.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Data-Subscription
 */
export const useMutationRerunExecutionLog = (
  options?: RerunExecutionLogMutationOptions,
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (logId: UUID) => rerunExecutionLog(logId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: queryKeysDataSubscription.executionLog(),
      });
    },
    ...options,
  });
};
